<style lang="scss" scoped>
.user-image {
	object-fit: cover;
	border-radius: 50%;
	background: #e3eaee;
	flex: none;
}
</style>

<template>
    <img v-if="image" class="user-image" :style="{ width: size + 'px', height: size  + 'px'}" :src="getImage(image)">
    <div v-else class="user-image d-flex" :style="{ width: size + 'px', height: size  + 'px'}">
        <i-profile class="m-auto" :style="{ width: size / 2 + 'px', height: size / 2  + 'px'}"></i-profile>
    </div>
</template>

<script>
export default {
	name: 'profile-image',
	props: {
		/**
		 * Object defining the user object
		 * @type {Object}
		 */
		user: {
			type: Object,
			default: () => {
				return {}
			}
		},

		/**
		 * Number defining the size of the image
		 * @type {Number}
		 */
		size: {
			type: Number,
			default: 30
		}
	},
	computed: {
		image() {
			let image = false
			if (this.user.profile_picture) image = this.user.profile_picture.image.medium.url
			return image
		}
	}
}
</script>
